import { z } from "zod";

export const locationDocSchema = z.object({
    id: z.coerce.string(),
    name: z.string(),
});

export const locationsResponseSchema = z.object({
    InstallLocations: z.object({
        docs: z.array(locationDocSchema),
    }),
});
